import { defineMessages } from 'react-intl';

export default defineMessages({
    breakInCoverage: {
        id: 'breakincoverage',
        defaultMessage: 'Break in coverage less than 60 days'
    }
});
